module.exports = __webpack_public_path__ + "static/img/dev3.471c2e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/development/dev3.jpg
// module id = 0Xnd
// module chunks = 0